import React, { useState } from 'react'
import { BsPlusCircleFill } from "react-icons/bs"
import { Button, Form, Row, Col } from "react-bootstrap"
import { withTranslation } from 'react-i18next';
import { Field, Formik } from "formik"
import * as Yup from 'yup';
import { RECETA_SAVE } from '../../api/Routes'
import Post from "../../api/Post";
import SimpleLoad from "../../loader/SimpleLoad";
import ItemMedicamento from './ItemMedicamento';
import ComponentModalErrorSever from '../ComponentModalErrorSever';
import {canEditDoctor} from "../../utils/isDoctor";

function DoctorReceta({ t, notify, appointmentReceta, citaID, auth, readOnly, cita }) {
    const [showForm, setShowForm] = useState(false)
    const [loading, setLoading] = useState(false)
    const [receta, setReceta] = useState(appointmentReceta)
    const [showBtnGuardar, setShowBtnGuardar] = useState(false)
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)
    // Determine country: 2 = Colombia, 1 or other = Mexico
    const isColombia = auth?.data?.company?.id === 2
    const [initialValues, setInitialValues] = useState({
        dias: '',
        horas: '',
        indicaciones: '',
        medicamento: '',
        gramaje: '',
        presentacion: '',
        dosis: '',
        administracion: '',
        cantidad: '',
    })
    const shemaValidate = Yup.object().shape({
        dias: Yup.number().min(1, t('mayor_a_cero')).required(t('Camporequerido')),
        horas: Yup.number().min(1, t('mayor_a_cero')).required(t('Camporequerido')),
        indicaciones: Yup.string().required(t('Camporequerido')),
        medicamento: Yup.string().required(t('Camporequerido')),
        // Colombia-only fields
        ...(isColombia && {
            gramaje: Yup.string().required('Campo requerido'),
            cantidad: Yup.number().min(1, t('mayor_a_cero')).required(t('Camporequerido')),
        }),
        presentacion: Yup.string().required('Campo requerido'),
        administracion: Yup.string().required('Campo requerido'),
        dosis: Yup.string().required('Campo requerido'),
    });

    let recetaDefault = {
        idCita: citaID,
        medicamentoList: []
    }

    const handleShowForm = () => setShowForm(!showForm)

    const handleDeleteMedicamento = index => {
        receta.medicamentoList.splice(index, 1)
        setReceta({
            ...receta,
        })
        setShowBtnGuardar(true)
    }

    const handleSaveReceta = () => {
        setLoading(true)

        Post({ url: RECETA_SAVE, data: receta, access_token: auth.data.access_token, header: true })
            .then(resp => {
                console.log(resp)
                setReceta(resp?.data.data)
                setLoading(false)
            })
            .catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
                setLoading(false)
            })
    }

    return (
        <div className="p-3 pt-4 position-relative">
            <ComponentModalErrorSever
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
            {loading && <SimpleLoad />}
            {
                !showForm
                    ? <>
                        {!readOnly && canEditDoctor(cita, auth) && <div className='cita-btn-add-container' onClick={handleShowForm}>
                            <BsPlusCircleFill className="cita-btn-add-item" /> &nbsp;
                            <Button variant="outline-primary" type="button" size="sm" >
                                {t('agregar_medicamento')}
                            </Button>{' '}
                        </div>}
                        {
                            receta && receta?.medicamentoList.map((item, i) =>
                                <ItemMedicamento key={`${i}-${item?.medicamento}`}
                                    item={item}
                                    position={i}
                                    handleDeleteMedicamento={handleDeleteMedicamento}
                                    readOnly={readOnly}
                                    isColombia={isColombia} auth={auth} cita={cita}
                                />)
                        }

                        {
                            showBtnGuardar && <Row className="grupoBotones">
                                <Col className="text-right">
                                    <Button variant="outline-primary"
                                        className="ok-buttom"
                                        type="button"
                                        onClick={handleSaveReceta}
                                    > {t('guardar')} </Button>{' '}
                                </Col>
                            </Row>
                        }
                    </>
                    : <>
                        {!loading && <Formik initialValues={initialValues}
                            validationSchema={shemaValidate}
                            onSubmit={(values, { setSubmitting, setFieldValue }) => {
                                setLoading(true)
                                const data = receta ? { ...receta, medicamentoList: [...receta?.medicamentoList, values] } : { ...recetaDefault, medicamentoList: [values] }
                                setReceta(data)
                                setInitialValues({
                                    dias: '',
                                    horas: '',
                                    indicaciones: '',
                                    medicamento: '',
                                    gramaje: '',
                                    presentacion: '',
                                    administracion: '',
                                    dosis: '',
                                    cantidad: '',
                                })
                                setShowBtnGuardar(true)
                                handleShowForm()
                                setLoading(false)
                            }}>{({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                setFieldValue
                            }) => (<Form onSubmit={handleSubmit} className='mt-3'>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">
                                                {isColombia ? "Principio Activo (Nombre Comercial)" : t('medicamento')}
                                            </Form.Label>
                                            <Field
                                                as="textarea"
                                                className={`form-control input-form ${errors.medicamento && 'error'}`}
                                                name="medicamento"
                                            />
                                            {errors.medicamento && <div className="invalid-feedback d-block">{errors.medicamento}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {isColombia && (
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary"> Concentracion </Form.Label>
                                                <Field
                                                    className={`form-control input-form ${errors.gramaje && 'error'}`}
                                                    name="gramaje"
                                                />
                                                {errors.gramaje && <div className="invalid-feedback d-block">{errors.gramaje}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">
                                                {isColombia ? "Forma Farmaceutica (Presentacion)" : "Presentacion"}
                                            </Form.Label>
                                            <Field
                                                className={`form-control input-form ${errors.presentacion && 'error'}`}
                                                name="presentacion"
                                            />
                                            {errors.presentacion && <div className="invalid-feedback d-block">{errors.presentacion}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">
                                                {isColombia ? "Via de administracion" : "Administracion"}
                                            </Form.Label>
                                            <Field
                                                className={`form-control input-form ${errors.administracion && 'error'}`}
                                                name="administracion"
                                            />
                                            {errors.administracion && <div className="invalid-feedback d-block">{errors.administracion}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary"> Dosis </Form.Label>
                                            <Field
                                                className={`form-control input-form ${errors.dosis && 'error'}`}
                                                name="dosis"
                                            />
                                            {errors.dosis && <div className="invalid-feedback d-block">{errors.dosis}</div>}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary">
                                                {isColombia ? "¿Cada Cuantas Horas?" : t('ciclo_horas')}
                                            </Form.Label>
                                            <Field
                                                type="number"
                                                className={`form-control input-form ${errors.horas && 'error'}`}
                                                name="horas"
                                                onChange={e => {
                                                    e.preventDefault();
                                                    const { value } = e.target;
                                                    const regex = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
                                                    if (regex.test(value.toString())) {
                                                        setFieldValue("horas", value);
                                                    }
                                                }}
                                            />
                                            {errors.horas && <div className="invalid-feedback d-block">{errors.horas}</div>}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary"> {t('cuantos_dias')} </Form.Label>
                                            <Field
                                                type="number"
                                                className={`form-control input-form ${errors.dias && 'error'}`}
                                                name="dias"
                                                onChange={e => {
                                                    e.preventDefault();
                                                    const { value } = e.target;
                                                    const regex = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
                                                    if (regex.test(value.toString())) {
                                                        setFieldValue("dias", value);
                                                    }
                                                }}
                                            />
                                            {errors.dias && <div className="invalid-feedback d-block">{errors.dias}</div>}
                                        </Form.Group>
                                    </Col>
                                    {isColombia && (
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary"> Total De Unidades Requeridas </Form.Label>
                                                <Field
                                                    type="number"
                                                    className={`form-control input-form ${errors.cantidad && 'error'}`}
                                                    name="cantidad"
                                                    onChange={e => {
                                                        e.preventDefault();
                                                        const { value } = e.target;
                                                        const regex = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/;
                                                        if (regex.test(value.toString())) {
                                                            setFieldValue("cantidad", value);
                                                        }
                                                    }}
                                                />
                                                {errors.cantidad && <div className="invalid-feedback d-block">{errors.cantidad}</div>}
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label className="font-weight-bold-600 text-secondary"> {t('indicaciones')} </Form.Label>
                                            <Field
                                                as="textarea"
                                                className={`form-control input-form ${errors.indicaciones && 'error'}`}
                                                name="indicaciones"
                                            />
                                            {errors.indicaciones && <div className="invalid-feedback d-block">{errors.indicaciones}</div>}
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row className="grupoBotones">
                                    <Col>
                                        <Button variant="danger" className="cancelar-buttom" type="button" onClick={handleShowForm}>Cancelar</Button>{' '}
                                    </Col>
                                    <Col className="text-right">
                                        <Button variant="outline-success" className="ok-buttom" type="submit"> {t('agregar')} </Button>{' '}
                                    </Col>
                                </Row>
                            </Form>)}</Formik>}
                    </>
            }
        </div>
    )
}
export default withTranslation()(DoctorReceta)